// extracted by mini-css-extract-plugin
export default {"wrapper":"MPs_wrapper__kiktV","cards":"MPs_cards__xq9Sp","card":"MPs_card__YGN4e","image":"MPs_image__bMf9G","title":"MPs_title__50sjJ","dates":"MPs_dates__JG9iL"};